export default{
    INTERNAL: {
        code: 'INTERNAL',
        status: 500,
        message: 'Internal server error',
        customMessage: 'Internal server error'
    },
    UNAUTHORIZED: {
        code: 'UNAUTHORIZED',
        status: 401,
        message: 'Unauthorized access',
        customMessage: 'You do not have access'
    },
    NOT_IMPLEMENTED: {
        code: 'NOT_IMPLEMENTED',
        status: 501,
        message: 'Resource method not implemented',
        customMessage: 'Resource method not implemented'
    },
    INVALID_INPUT: {
        code: 'INVALID_INPUT',
        status: 400,
        message: 'Invalid input in request',
        customMessage: 'Invalid input in request'
    },
    INVALID_LOGIN: {
        code: 'INVALID_LOGIN',
        status: 400,
        message: 'Invalid login credentials',
        customMessage: 'Invalid login credentials'
    },
    NOT_FOUND: {
        code: 'NOT_FOUND',
        status: 404,
        message: 'No such resource exists',
        customMessage: 'No such resource exists'
    },
    NOT_ALLOWED: {
        code: 'NOT_ALLOWED',
        status: 403,
        message: 'Operation not allowed',
        customMessage: 'Operation not allowed'
    },
    NO_ACCESS: {
        code: 'NO_ACCESS',
        status: 403,
        message: 'Access not allowed',
        customMessage: 'Access not allowed'
    },
    ALREADY_EXISTS: {
        code: 'ALREADY_EXISTS',
        status: 409,
        message: 'Resource already exists',
        customMessage: 'Resource already exists'
    },
    SIZE_LIMIT: {
        code: 'SIZE_LIMIT',
        status: 413,
        message: 'Input size exceeds allowed limits',
        customMessage: 'Input size exceeds allowed limits'
    },
    RATE_LIMIT: {
        code: 'RATE_LIMIT',
        status: 429,
        message: 'Request rate exceeds allowed limits',
        customMessage: 'Request rate exceeds allowed limits'
    },
    EMAIL_ALREADY_VERIFIED: {
        code: "EMAIL_ALREADY_VERIFIED",
        status: 403,
        message: "Email is already verified",
        customMessage: 'Email is already verified'
    }, EMAIL_ALREADY_REGISTERED: {
        code: 'EMAIL_ALREADY_REGISTERED',
        status: 403,
        message: 'This e-mail address is already registered with Accura',
        customMessage: 'This e-mail address is already registered with Accura'
    },
    STRIPE_ERROR: {
        code: "STRIPE_ERROR",
        status: 403,
        message: "Unable to update stripe source, This card type MasterCard is not accepted.",
        customMessage: 'Unable to update stripe source, This card type MasterCard is not accepted.'
    },
    UNKNOWN_ERROR: {
        code: 'UNKNOWN_ERROR',
        status: 429,
        message: 'Unknown error occurred, Please try again',
        customMessage: 'Unknown error occurred, Please try again'
    },
    PERMISSION_REVOKED: {
        code: 'PERMISSION_REVOKED',
        status: 405,
        message: 'Unknown error occurred, Please try again',
        customMessage: 'You do not have appropriate permission'
    }
}